// src/utils/officeType.js
// 从 localStorage 登录用户中解析出 officeId
import StorageUtil from './storage'

// 登录返回 res.data.sysAccount 为账号实体（与 system-mobile 移动端取值一致）
export function getOfficeIdFromStorage() {
  let user = null
  try {
    const raw = StorageUtil.getItemSync('user')
    user = raw ? JSON.parse(raw) : null
  } catch (e) {
    user = null
  }
  const officeId = user?.sysAccount?.officeId
  return officeId !== null && officeId !== undefined ? String(officeId) : ''
}
